"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAPKA_SINIFI = exports.SAPKA_ETIKETI = void 0;
exports.sapkaSinifi = sapkaSinifi;
exports.izinliBahceTurleri = izinliBahceTurleri;
exports.bahceDerinligiIhlali = bahceDerinligiIhlali;
/**
 * ŞAPKA → SINIF (Kapsam §20.2 Y2 tablosu).
 *
 * ⚠️ **v1'de alan sahipliğinin TEK ÜYESİ `area_supervisor`dır** ve bu bir
 * eksiklik değil tasarımdır: o şapkanın varlık sebebi *"şu alanın
 * sorumlusu"* olmasıdır ve **PTW onay kuralı buna dayanır** (onaylayan
 * alanın sorumlusudur, amir değil — `.claude/rules/ptw.md`). O şapkadan dal
 * inceliğini almak, onayı **alan ekseninden hiyerarşi eksenine** kaydırırdı.
 *
 * ✏️ **REVİZYON İZİ — `location_manager` KAPSAMA'DIR** (ürün sahibi
 * 27.08.2026; rol modeli tutanağı v1.0 §C *"bahçesi lokasyon dalı"* diyordu,
 * **silinmedi, arşivde kendi tarihiyle durur**). Gerekçe: *santral müdürü bir
 * alanın değil bir işletmenin sorumlusudur; dal bahçesi ona EKSİK bir işyeri
 * verirdi* — ünite eklendiğinde müdür onu görmezdi.
 *
 * ⚠️ **YENİ ŞAPKA EKLENİRKEN SINIFI SORULUR.** Bu haritanın eksiksizliği
 * testle kilitlidir (`yetki.spec.ts`): `ROLE_TYPES`e değer eklenip buraya
 * satır eklenmezse derleme/test kırmızı yanar. Sınıfsız şapka bahçe alamaz —
 * §20.5'in *yaşayan tablo* kuralının bahçe tarafındaki kardeşi.
 */
/**
 * ŞAPKA ETİKETLERİ — TEK GÖVDE (PTW onay düğmesi, 14.09.2026 — K-62b; tur 10 /
 * K7.1 deseni: *harita yazılmaz, import edilir*). Web `SAPKA_ETIKET` bunu
 * yeniden dışa verir; sunucu ret mesajları (boş havuz — `PtwHavuzBosError`)
 * ham token yerine bu etiketi basar (D2). Enum'a Türkçe metin girmez (§10);
 * etiket buradadır.
 */
exports.SAPKA_ETIKETI = {
    // ✏️ 28.10.2026 (Kapsam §14 DT-4): ekran etiketi "Merkez Yöneticisi" — kod adı
    // (`holding_admin`) ve belge dili (*holding yöneticisi*) DEĞİŞMEDİ; tenant
    // bazlı etiket white-label açık ucu (madde 312).
    holding_admin: 'Merkez Yöneticisi',
    company_admin: 'Şirket yöneticisi',
    location_manager: 'Proje/Lokasyon yöneticisi',
    isg_specialist: 'İSG uzmanı',
    isg_technician: 'İSG teknikeri',
    physician: 'İşyeri hekimi',
    ysp: 'Diğer sağlık personeli',
    area_supervisor: 'Saha/Kısım sorumlusu',
    employee: 'Çalışan',
    employee_rep: 'Çalışan temsilcisi',
    contractor_rep: 'Yüklenici temsilcisi',
    viewer: 'İzleyici',
};
exports.SAPKA_SINIFI = {
    holding_admin: 'bahcesiz',
    viewer: 'bahcesiz',
    area_supervisor: 'alan_sahipligi',
    company_admin: 'kapsama',
    location_manager: 'kapsama',
    isg_specialist: 'kapsama',
    isg_technician: 'kapsama',
    physician: 'kapsama',
    ysp: 'kapsama',
    employee: 'kapsama',
    employee_rep: 'kapsama',
    contractor_rep: 'kapsama',
};
/** Şapkanın sınıfı. Harita eksiksizdir (testli) — varsayılana düşülmez. */
function sapkaSinifi(sapka) {
    return exports.SAPKA_SINIFI[sapka];
}
/**
 * Bir şapkanın alabileceği bahçe türleri — **bahçe yazma kapısının okuduğu
 * tek kaynak** ve (B2'de) seçim ağacının derinliğini belirleyen liste.
 *
 * ⚠️ `contractor` her iki sınıfta da vardır: yüklenici bahçesi **tenant
 * düzeyindedir** (bir lokasyon ekseni yoktur) ve dağıtımını yalnız holding
 * yöneticisi yapar — o sınır **derinlik değil YETKİ** meselesidir ve kendi
 * yerinde (uç) durur.
 */
function izinliBahceTurleri(sapka) {
    switch (sapkaSinifi(sapka)) {
        case 'bahcesiz':
            return [];
        case 'alan_sahipligi':
            return ['company', 'workplace', 'location_branch', 'contractor'];
        case 'kapsama':
            return ['company', 'workplace', 'contractor'];
    }
}
/**
 * Bahçe derinliği ihlali — ihlal varsa **kullanıcıya gösterilecek metin**,
 * yoksa `null`. Çağıran bunu **422**'ye çevirir (kural ihlali; 403 değil —
 * yetki sorunu değildir, aynı kişi aynı hedefe `workplace` bahçesini
 * yazabilir).
 *
 * ⚠️ **D2 — SIZDIRMAZ DİL:** mesaj hedefin adını, işyerini, şirketi ya da
 * ağacın şeklini **taşımaz**; yalnız kuralı söyler. Bahçe dışı bir düğümün
 * varlığı/adı, o düğümü görmeyen kişiye hata metniyle sızmamalıdır.
 */
function bahceDerinligiIhlali(sapka, kapsamTip) {
    const sinif = sapkaSinifi(sapka);
    if (sinif === 'bahcesiz') {
        // Mevcut davranış korunur (§20.5/B2 — F1·S5'ten beri 422).
        return 'Bu şapka bahçe kaydı almaz — kapsamı holding geneli';
    }
    if (izinliBahceTurleri(sapka).includes(kapsamTip))
        return null;
    return 'Bu şapka lokasyon dalı bahçesi alamaz — kapsamı işyeri düzeyinde durur';
}
//# sourceMappingURL=yetki.js.map